module.exports = "pegasus/assets/themelp1/small/1.png";